import { createAsyncThunk, createReducer, createSlice } from '@reduxjs/toolkit';
import {fetchWrapper } from '../_helpers';

//create slice
const name = "stockManagement";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers= (builder) => {
    createExtraReducers(builder);
}
const slice = createSlice({name,initialState,reducers,extraReducers});

//exports
export const stockManagementActions = {...slice.actions,...extraActions};
export const stockManagementReducer = slice.reducer;

//implementation
function createInitialState() {
    return {
        stockList: [],
        error: null,
        stockResponse: []
    }
}

function createReducers() {
    return {
        clearStockResponse
    };

    function clearStockResponse(state) {
        state.stockResponse = [];
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/Inventory`;

    return {
        getStockList: getStockList()
    };

    function getStockList() {
        return createAsyncThunk(
            `${name}/GetInventoryDetails`,
            async (StockDetail) => await fetchWrapper.post(`${baseUrl}/GetInventoryDetails?ProductID=${StockDetail.ProductID}
            &ProductName=${StockDetail.ProductName}&CategoryID=${StockDetail.CategoryID}&SKU=${StockDetail.SKU}&Location=${StockDetail.Location}`)
        );
    }
}

function createExtraReducers(builder) {
    builder
        .addCase(extraActions.getStockList.pending, (state) => {
            state.error = ""; // Reset error state
        })
        .addCase(extraActions.getStockList.fulfilled, (state, action) => {
            state.stockList = action.payload || []; // Set stockList to payload or an empty array if undefined
        })
        .addCase(extraActions.getStockList.rejected, (state, action) => {
            state.error = { error: action.error }; // Set error state on rejection
        });
}